import React from "react";
import Header from "../Header/Header";

function HomeInicio() {
  return (
    <>
      <Header />
      <div className="inicio-portada">
        <img
          src={process.env.PUBLIC_URL + "/logoInstitucion.png"}
          alt="Cavanna Mezclilla"
          className="inicio-logo"
        />
        <p className="inicio-leyenda">Sistema de confección</p>
      </div>
    </>
  );
}

export default HomeInicio;
